import { pbCollections } from "../../Consts/Consts";
import { PointsResponse, TripsMetaDataResponse } from "../../pocketbase-types";
import { Trip } from "../../Types/Trip";
import { pbClient } from "./pb";

export const CreatePBTrip = async (trip: Trip) => {
    try {
        const tripId = await pbClient.send(`/api/transaction/trip`, {
            body: JSON.stringify(trip),
            method: "POST",
        }) as string;
        return tripId
    } catch (error) {
        console.error("create trip error =>", error);
    }
}

export const DeleteTrip = async (tripId: string) => {
    try {
        await pbClient.send('', { tripId })
    } catch (error) {
        console.error("delete trip error =>", error);
    }
}


export const getTripsMetaData = async () => {
    const trips = await pbClient.collection(pbCollections.tripsMetaData).getFullList({
        sort: '-created',
    }) as TripsMetaDataResponse[];
    return trips
}

type ExpandedTripsMetaDataResponse = TripsMetaDataResponse & { expand?: { points?: Array<PointsResponse> } }
export const getTripMetaData = async (tripId: string, withPoints?: boolean) => {
    const trip = await pbClient.collection(pbCollections.tripsMetaData).getOne(tripId) as ExpandedTripsMetaDataResponse;
    if (withPoints) {
        const points = await getSelectedTripMetaDataPoints(trip.points)
        trip.expand = { points }
    }
    return trip
}

export const getSelectedTripMetaDataPoints = async (tripPointsIds: string[]) => {
    const pointsFilter = tripPointsIds.map(p => `id = '${p}'`).join('||')
    const points = await pbClient.collection(pbCollections.points).getFullList({
        filter: pbClient.filter(pointsFilter)
    }) as PointsResponse[]
    return points
}


export const subTottrip = async (tripId: string) => {
    // Subscribe to changes only in the specified record
    const unsub = await pbClient.collection(pbCollections.trips).subscribe(tripId, function (e) {
        console.log(e.action);
        console.log(e.record);
    }, { /* other options like expand, custom headers, etc. */ });
    return unsub
}